module.exports = require("shallowequal");